/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Ordering is important here
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.3.0
 */

import { IAction } from '../../modules/app/createAction';
import { EOnboardingComponentsId } from '../../modules/onboarding/types/onboardingTypes';
import { AccessComponentKeyEnum } from '../../modules/role/constants/guard/guardConstants';
import { RoutePath } from '../../routes/constants/routesConstants';
import { SETTINGS_LOADER_START, SETTINGS_LOADER_STOP } from './settingsConstants';

export enum SettingsMenuItems {
    PROFILE = 'profile',
    AUTOREPORTS = 'autoreports',
    STATISTICS = 'statistics',
    LABELS = 'labels',
    POSITIONS = 'positions',
    NOTIFICATIONS = 'notifications',
}

interface IMapSettingsMenuItems {
    [key: string]: {
        accessKey?: AccessComponentKeyEnum;
        onboarding?: EOnboardingComponentsId;
        url: string;
    };
}

export const mapSettingsMenuItems: IMapSettingsMenuItems = {
    [SettingsMenuItems.PROFILE]: {
        onboarding: EOnboardingComponentsId.settingsTabProfile,
        url: RoutePath.settingsProfile,
    },
    [SettingsMenuItems.AUTOREPORTS]: {
        accessKey: AccessComponentKeyEnum.PageSettingsMenuAutoReports,
        url: RoutePath.settingsAutoReports,
    },
    [SettingsMenuItems.STATISTICS]: {
        accessKey: AccessComponentKeyEnum.PageSettingsMenuStatistics,
        url: RoutePath.settingsStatistics,
    },
    [SettingsMenuItems.LABELS]: {
        accessKey: AccessComponentKeyEnum.PageSettingsMenuLabels,
        onboarding: EOnboardingComponentsId.settingsTabLabels,
        url: RoutePath.settingsLabels,
    },
    [SettingsMenuItems.POSITIONS]: {
        accessKey: AccessComponentKeyEnum.PageSettingsMenuPositions,
        onboarding: EOnboardingComponentsId.settingsTabPositions,
        url: RoutePath.settingsPositions,
    },
    [SettingsMenuItems.NOTIFICATIONS]: {
        accessKey: AccessComponentKeyEnum.notifications,
        onboarding: EOnboardingComponentsId.settingsTabNotifications,
        url: RoutePath.settingsNotifications,
    },
};

export interface ISettingsCommonReducer {
    isShowLoading: boolean;
}

/*
 * -------------------------------------------
 *           ACTIONS
 * -------------------------------------------
 */

export type TSettingsLoaderStartAction = IAction<typeof SETTINGS_LOADER_START>;
export type TSettingsLoadersStopAction = IAction<typeof SETTINGS_LOADER_STOP>;

export type TSettingsCommonActionTypes = TSettingsLoaderStartAction | TSettingsLoadersStopAction;
